var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "persistent": ""
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "risk-assessment",
    attrs: {
      "height": "100%"
    }
  }, [_c('v-form', {
    ref: "form",
    staticClass: "scroll-form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: _vm.valid,
      callback: function callback($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-card-title', {
    staticClass: "headline indigo darken-4 white--text fixed-header",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.powra.pointOfWorkRiskAssessment').toUpperCase()) + "\n        ")]), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('PowraTitle', {
    attrs: {
      "avatar": 'G',
      "title": _vm.$vuetify.t('$vuetify.powra.sectionGHeadline')
    }
  }), _vm._l(_vm.hazards, function (hazard, index) {
    return hazard ? _c('v-flex', {
      key: index,
      class: index % 2 == 0 ? 'subheading font-weight-bold blue-grey lighten-5' : 'subheading font-weight-bold',
      attrs: {
        "xs12": "",
        "px-3": "",
        "py-3": ""
      }
    }, [_vm._v("\n            " + _vm._s(hazard.name)), _c('br'), _c('v-select', {
      staticClass: "mt-3",
      attrs: {
        "items": _vm.newControlMeasures,
        "label": _vm.$vuetify.t('$vuetify.powra.controlMeasure'),
        "outline": "",
        "rules": _vm.controlMeasuresRules,
        "required": "",
        "item-text": "name",
        "item-value": "code",
        "multiple": "",
        "return-object": ""
      },
      model: {
        value: _vm.hazardControls[hazard.code].controls,
        callback: function callback($$v) {
          _vm.$set(_vm.hazardControls[hazard.code], "controls", $$v);
        },
        expression: "hazardControls[hazard.code].controls"
      }
    }), _c('v-text-field', {
      attrs: {
        "label": _vm.$vuetify.t('$vuetify.powra.comments'),
        "outline": ""
      },
      model: {
        value: _vm.hazardControls[hazard.code].comments,
        callback: function callback($$v) {
          _vm.$set(_vm.hazardControls[hazard.code], "comments", $$v);
        },
        expression: "hazardControls[hazard.code].comments"
      }
    })], 1) : _vm._e();
  })], 2), _c('div', {
    staticClass: "footer text-xs-center mb-3"
  }, [_c('v-divider'), _c('v-card-text', [_c('v-btn', {
    on: {
      "click": function click($event) {
        return _vm.back();
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$vuetify.t('$vuetify.calls.back')) + "\n            ")]), _c('v-btn', {
    attrs: {
      "color": "success",
      "disabled": !_vm.valid
    },
    on: {
      "click": function click($event) {
        return _vm.confirm();
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$vuetify.t('$vuetify.calls.proceedToTheNextSection')) + "\n            ")]), _c('abort-visit', {
    on: {
      "aborted": function aborted($event) {
        var _vm2;
        return (_vm2 = _vm).visitAborted.apply(_vm2, arguments);
      }
    }
  })], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }